"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _environment = _interopRequireDefault(require("../environment"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Cookie Utilities to more easily manage cookie options
 */

/**
 * Get the environment suffix based on the current environment
 * @returns Environment suffix based on the current environment
 */
const getEnvironmentSuffix = () => {
  const environment = (0, _environment.default)();
  if (environment === 'production') {
    return '';
  }
  return `-${environment}`;
};

/**
 * Get the domain to use for cookies based on the environment
 */
const getCookieDomain = () => {
  return (0, _environment.default)() === 'development' ? undefined : 'zola.com';
};

/**
 * Add property to use cookie with subdomains
 *
 * @param cookieOptions json object of cookie options
 */
const addSubdomains = cookieOptions => Object.assign(cookieOptions, {
  domain: getCookieDomain()
});

/** *************
 * Login Cookie
 ************** */

/**
 * Get the login cookie name based on environment
 */
const getLoginCookieName = () => {
  return `guid${getEnvironmentSuffix()}`;
};

/**
 * Get standard login cookie options
 *
 * @param req Express request object
 */
const getLoginCookieOptions = (req, isGuest) => {
  const referrer = req.get('Referrer');
  let sameSite;
  // Not set in development because some browsers require secure context
  if (referrer !== null && referrer !== void 0 && referrer.endsWith('zola.com/external/bookmarklet')) {
    sameSite = 'none';
  }
  return addSubdomains({
    sameSite,
    maxAge: isGuest ? 7776000000 : 31536000000,
    httpOnly: true,
    secure: sameSite === 'none' || req.secure,
    encode: String
  });
};

/**
 * Set Zola's login cookie with appropriate options with a given value
 *
 * @param req Express request object
 * @param res Express response object
 * @param value Login cookie value
 */
const setLoginCookie = (req, res, value, isGuest) => {
  const cookieName = getLoginCookieName();
  req.cookies[cookieName] = value;
  return res.cookie(getLoginCookieName(), value, getLoginCookieOptions(req, isGuest));
};

/**
 * Get login cookie value
 *
 * @param req Express request object
 */
const getLoginCookie = req => {
  if (!req.cookies) return undefined;
  return req.cookies[getLoginCookieName()];
};

/**
 * Clear older session and login cookies that did not have domain set
 * Clearing cooking requires path and domain to match or it won't clear
 *
 * @param res Express response object
 */
const clearLegacyLoginCookies = res => {
  res.clearCookie('PLAY_SESSION', {
    expires: new Date(1),
    maxAge: 0
  });
  res.clearCookie('guid', {
    expires: new Date(1),
    maxAge: 0
  });
  res.clearCookie('zolaLoggedIn', {
    expires: new Date(1),
    maxAge: 0
  });
};

/**
 * Clear the login cookie
 *
 * @param res Express respose object
 */
const clearLoginCookie = res => {
  res.clearCookie(getLoginCookieName(), addSubdomains({
    expires: new Date(1),
    maxAge: 0
  }));
  if ((0, _environment.default)() === 'production') {
    clearLegacyLoginCookies(res);
  }
};

/** ********************
 * User Session Cookies
 *********************** */

/**
 * Gets the user session cookie name based on the current environment
 * @returns User session cookie name
 */
const getUserSessionCookieName = () => {
  return `us${getEnvironmentSuffix()}`;
};
const setUserSessionCookie = (req, res, value) => {
  const cookieName = getUserSessionCookieName();
  req.cookies[cookieName] = value;
  return res.cookie(cookieName, value, getLoginCookieOptions(req, false));
};
const getUserSessionCookie = req => {
  if (!req.cookies) return undefined;
  return req.cookies[getUserSessionCookieName()];
};
const clearUserSessionCookie = res => {
  res.clearCookie(getUserSessionCookieName(), addSubdomains({
    expires: new Date(1),
    maxAge: 0
  }));
};
const getUserSessionRefreshCookieName = () => {
  return `usr${getEnvironmentSuffix()}`;
};
const setUserSessionRefreshCookie = (req, res, value) => {
  const cookieName = getUserSessionRefreshCookieName();
  req.cookies[cookieName] = value;
  return res.cookie(cookieName, value, getLoginCookieOptions(req, false));
};
const getUserSessionRefreshCookie = req => {
  if (!req.cookies) return undefined;
  return req.cookies[getUserSessionRefreshCookieName()];
};
const clearUserSessionRefreshCookie = res => {
  res.clearCookie(getUserSessionRefreshCookieName(), addSubdomains({
    expires: new Date(1),
    maxAge: 0
  }));
};
const setUserSessionCookies = (req, res, sessionToken, refreshToken) => {
  setUserSessionCookie(req, res, sessionToken);
  setUserSessionRefreshCookie(req, res, refreshToken);
};
const clearAuthCookies = res => {
  clearLoginCookie(res);
  clearUserSessionCookie(res);
  clearUserSessionRefreshCookie(res);
};
var _default = exports.default = {
  addSubdomains,
  clearLegacyLoginCookies,
  clearLoginCookie,
  getCookieDomain,
  getLoginCookie,
  getLoginCookieName,
  getLoginCookieOptions,
  setLoginCookie,
  setUserSessionCookie,
  getUserSessionCookie,
  clearUserSessionCookie,
  getUserSessionCookieName,
  setUserSessionRefreshCookie,
  getUserSessionRefreshCookie,
  clearUserSessionRefreshCookie,
  getUserSessionRefreshCookieName,
  setUserSessionCookies,
  clearAuthCookies
};